/**
 * Helper format teks panduan. Dipakai oleh halaman /help dan scripts/build-help-pdf.js.
 * ES module; dimuat Node lewat import() dinamis.
 */

function escapeHtml (s) {
  return String(s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
}

// **tebal**, *miring*, `kode` -> HTML aman (teks di-escape lebih dulu).
function fmt (s) {
  return escapeHtml(s)
    .replace(/`([^`]+)`/g, '<code>$1</code>')
    .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
    .replace(/\*([^*]+)\*/g, '<em>$1</em>')
}

function slugify (s) {
  return String(s).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '')
}

// Teks polos sebuah blok, untuk pencarian.
function blockText (b) {
  if (b.p) return b.p
  if (b.h3) return b.h3
  if (b.list) return b.list.join(' ')
  if (b.steps) return b.steps.join(' ')
  if (b.callout) return b.text
  if (b.img) return b.caption || ''
  if (b.table) return b.table.head.join(' ') + ' ' + b.table.rows.map(r => r.join(' ')).join(' ')
  return ''
}

const CALLOUT_LABEL = { info: 'Info', penting: 'Penting', tips: 'Tips', catatan: 'Catatan' }

export { escapeHtml, fmt, slugify, blockText, CALLOUT_LABEL }
